import SelectTrainingProjects from './src/main';

/* istanbul ignore next */
SelectTrainingProjects.install = function(Vue) {
  Vue.component(SelectTrainingProjects.name, SelectTrainingProjects);
};

export default SelectTrainingProjects;
